import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { LiveSource } from '../../../domain/live-sources';
import {
  SOURCE_STATUS_META,
  DEFAULT_SOURCE_STATUS_META,
  SourceStatusMeta,
} from '../live-sources.constants';

@Component({
  selector: 'evrideo-live-source-card',
  templateUrl: './live-source-card.component.html',
  styleUrls: ['./live-source-card.component.scss'],
})
export class LiveSourceCardComponent implements OnChanges {
  @Input() source!: LiveSource;
  @Output() delete = new EventEmitter<void>();

  statusMeta: SourceStatusMeta = DEFAULT_SOURCE_STATUS_META;

  ngOnChanges(): void {
    if (!this.source) return;
    this.statusMeta = SOURCE_STATUS_META[this.source.status] ?? DEFAULT_SOURCE_STATUS_META;
  }

  onThumbnailError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.style.display = 'none';
  }

  onDelete(): void {
    this.delete.emit();
  }
}
